import { render } from "./Marshalls.vue?vue&type=template&id=3bb9ad14&scoped=true"
import script from "./Marshalls.vue?vue&type=script&lang=js"
export * from "./Marshalls.vue?vue&type=script&lang=js"

import "./Marshalls.vue?vue&type=style&index=0&id=3bb9ad14&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb9ad14"]])

export default __exports__